"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
function bySpecies() {
    var config = {
        delay: 10,
        nb: 200
    };
    var stopped;
    var doneCallback = null;
    function bySpeciesStrategy(gremlins, params, done) {
        var nb = params && params.nb ? params.nb : config.nb;
        var gremlinsCopy = gremlins.slice();
        var horde = this;
        stopped = false;
        doneCallback = done;
        function executeNext(gremlin, i, callback) {
            if (!gremlin || stopped) {
                return;
            }
            if (i >= nb) {
                return callback();
            }
            utils_1.executeInSeries([gremlin], [], horde, function () {
                setTimeout(function () {
                    executeNext(gremlin, ++i, callback);
                }, config.delay);
            });
        }
        function executeNextGremlin() {
            if (stopped)
                return;
            if (gremlinsCopy.length === 0) {
                return callDone();
            }
            executeNext(gremlinsCopy.shift(), 0, executeNextGremlin);
        }
        executeNextGremlin();
    }
    bySpeciesStrategy.stop = function () {
        stopped = true;
        setTimeout(callDone, 4);
    };
    function callDone() {
        if (typeof doneCallback === "function") {
            doneCallback();
        }
        doneCallback = null;
    }
    utils_1.configurable(bySpeciesStrategy, config);
    return bySpeciesStrategy;
}
exports.bySpecies = bySpecies;
